import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import NamedLink from '../NamedLink/NamedLink';

import css from './SectionNextBooking.module.css';
import {useBookingListQuery} from "@/v2/bookings/bookings.queries";
import BookingItem from "@/v2/bookings/components/BookingItem";

const SectionNextBooking = props => {
  const { className = null } = props;
  const {
    data: bookings = [],
    isPending,
  } = useBookingListQuery({ limit: 1 });
  const nextBooking = bookings[0]

  const classes = classNames(css.main, className);

  return (
    <div className={classes}>
      <div className={css.contentBox}>
        <div className={css.title}>
          <h2>Your next booking </h2>{' '}
        </div>
        <div>
          <p>
            {isPending
              ? `Loading your bookings, please wait`
              : nextBooking
              ? `To see the rest of your bookings, please click here`
              : `You currently have no upcoming bookings. To manage bookings please click
          here`}
          </p>
          <NamedLink name="ManageBookingsPage" className={css.bookingButton}>
            Your Bookings
          </NamedLink>
        </div>
      </div>
      {nextBooking ? <BookingItem booking={nextBooking} /> : null}
    </div>
  );
};

SectionNextBooking.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionNextBooking;
